export default __webpack_public_path__ + "static/media/difc.8d0ef473.webp";